//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
import { memo, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzDotsLoader, BzLoader } from '../../../components';
import { API_RESPONSE_STATUS, DISPLAY_EXCHANGE_NAME, FREQUENCY_TYPE, LAYOUT_TYPE, MARKET_SEGMENT_ID, ORDER_ENTRY_TYPES, ORDER_TYPES, ORDER_VALIDITY, SCRIP_INSTRUMENTS, TL_INDEX, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';
import { changeNumberFormatWithCurrecyUnit, convertNumberWithCommasForCurrency, getToFixedParseFloat, handleKeyDownOnDiv } from '../../../utils/global_functions';
import { useWFHMessages } from '../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { getTermsAndCondition } from '../../../redux/actions/appInfo';
import { handleModal } from '../../../redux/actions/modals';
import moment from 'moment';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';


const ConfirmationBody = ({ layoutType, scripOrderInfo, orderEntryTab, activeTabKey, selectOrderOption, nOrderValue,
    orderInputs, marginInfoHandler, bIsConfirmBtn, setBIsConfirmBtn, arrMultiLegInfo, bIsCoverBracketOrderOpen, GTDNoOfDays }) => {

    const dispatch = useDispatch();
    const objSingleScripOrderResp = useSelector(state => state.orders.singleScripOrder);
    const multiSpreadOrderInfo = useSelector(state => state.orders?.multiSpreadOrderInfo);
    const arrOrderCartScrips = useSelector(state => state?.orderCart?.arrOrderCartScrips);
    // BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    const objModalData = useSelector(state => state?.modals?.modalData);
    const arrOrderDetails = layoutType === LAYOUT_TYPE.VERTICAL ? arrOrderCartScrips : objModalData?.data?.orderCartConfirmation?.data?.orderCartInfo;//BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
    const [currentScripLiveData, setCurrentScripLiveData] = useState(scripOrderInfo);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);
    const orderCartMargin = useSelector(state => state?.orderCart?.orderCartMargin);
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    const arrOrderSliceData = objModalData?.data?.arrOrderSlicingInfo; //BT-138033 : Order Slicing: ManasaB : 26-06-2024
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    const updateLiveFeed = (liveData) => {
        const arrTLData = [...liveData];
        if (arrTLData?.length > 0 && scripOrderInfo?.length > 0 && arrTLData[TL_INDEX.SEGMENT_ID] === scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] && arrTLData[TL_INDEX.TOKEN] === scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN]) {
            setCurrentScripLiveData(curr => {
                curr[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTLData[TL_INDEX.LAST_TRADE_PRICE];
                curr[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTLData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                curr[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTLData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                return [...curr];
            });
        }
    };

    useWFHMessages('touchline', (e) => {
        updateLiveFeed([...e.detail]);
    });

    //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
    const bIsEqScripHaveLots = useMemo(() => scripOrderInfo && ((scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MSX_CASH) && scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT]?.toUpperCase() === SCRIP_INSTRUMENTS.EQUITIES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 1), [scripOrderInfo]);
    //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
    useEffect(() => {
        if (scripOrderInfo?.length > 0) {
            const arrScripSubscription = [{ exchangeId: scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }];
            sendTouchlineRequest(arrScripSubscription);

            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastTickScripData = objLastTickData[scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            if (arrLastTickScripData?.length > 0) {
                updateLiveFeed([...arrLastTickScripData]);
            } else { }
            marginInfoHandler();
        } else { }

        return () => {
            if (scripOrderInfo?.length > 0) {
                const arrScripSubscription = [{ exchangeId: scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }];
                sendTouchlineRequest(arrScripSubscription);
            } else { }
        };
    }, [scripOrderInfo, dispatch]);
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End


    const termsCondition = async () => {
        await dispatch(getTermsAndCondition('sip'));
        dispatch(handleModal([{ 'TERMS_CONDITION_MODAL': true }], true));
    };
    const bIsOrderEntryApiPending = useSelector(state => state.orders.bIsOrderEntryApiPending);

    const SingleScripListing = () => {
        return (
            scripOrderInfo?.length > 0 &&
            <Container fluid className='p-0'>
                {/* //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - Start */}
                {bIsOrderEntryApiPending ? <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                    <BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Placing Order" bIsFfromModal={true} />
                </div> : null}
                {/* //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - End */}
                <Row className='g-0  align-items-center'>
                    <Col md={4} className='d-flex justify-content-start align-items-center'>
                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                        <div className='chips-wrap'>
                            <div className='exchange-chip me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                        </div>
                    </Col>
                    <Col md={8}>
                        <div className='d-flex justify-content-end'>
                            <div className='font-medium font-size4 color-text text-truncate me-2'>{currentScripLiveData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                            <div className={`font-regular font-size4 color-text text-truncate ${Number(currentScripLiveData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) >= 0 ? 'color-positive' : 'color-negative'}`}> {currentScripLiveData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]} (
                                {currentScripLiveData?.[WATCHLIST_GRID_INDEX.LTP_PERCENT]}%)
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 mb-2'>
                    <Col>
                        <div className='d-flex'>
                            {scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE] &&
                                <div className='font-regular font-size2 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]}</div>
                            }
                            {scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] &&
                                <div className='font-regular font-size2 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES]}</div>
                            }
                            {scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                                <div className='font-regular font-size2 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.STRIKEPRICE]}</div>
                            }
                            {scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] &&
                                <div className='font-regular font-size2 color-subtext text-uppercase'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE]}</div>
                            }
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 py-2'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>Product Type</div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <div className='font-regular font-size3 color-text'>{selectOrderOption?.productTypeDesc}</div>
                    </Col>
                </Row>
                <Row className='g-0 py-2'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>
                            {selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked ? 'SL ' : null}    {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES && !bIsEqScripHaveLots ? `Quantity` : `Lot (Qty)`}
                        </div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <div className='font-regular font-size3 color-text'>
                            {/* //Azeem K : 28-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Bug Fixes - Start */}
                            {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES && !bIsEqScripHaveLots ? orderInputs?.scripQuantity : `${orderInputs?.scripLot} (${orderInputs?.scripQuantity}${scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT || scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT ? ' ' + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] : ''})`}
                            {/* //Azeem K : 28-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Bug Fixes - End */}
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 py-2'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>{selectOrderOption?.isOCOChecked ? 'SL Price' : 'Price'}</div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <div className='font-regular font-size3 color-text'>
                            <span>{selectOrderOption?.orderType?.includes('MKT') ? 'Market' : convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.scripPrice, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</span>
                        </div>
                    </Col>
                </Row>
                {
                    // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
                    (selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && orderInputs?.slTrigger > 0 &&
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>{selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && !selectOrderOption?.isOCOChecked ? 'Trigger Price' : 'SL Trigger'}</div>
                            {/* BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End  */}
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>
                                <span>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.slTrigger, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</span>
                            </div>
                        </Col>
                    </Row>
                }
                {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start  */}
                {selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked &&
                    <>
                        <Row className='g-0 py-2'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 color-subtext'>Target Price</div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <div className='font-regular font-size3 color-text'>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.targetSelPrice, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 py-2'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 color-subtext'>Target Trigger Price</div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <div className='font-regular font-size3 color-text'>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.targetSelTriggerPrice, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</div>
                            </Col>
                        </Row>
                    </>
                }
                {/* // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End  */}
                {/* {
                    bIsCoverBracketOrderOpen && orderInputs?.intradayTrigger > 0 &&
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='d-flex justify-content-start align-items-center'>SL Trigger</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.intradayTrigger, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</div>
                        </Col>
                    </Row>
                } */}
                {
                    bIsCoverBracketOrderOpen && orderInputs?.intradayLimit > 0 &&
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>SL Limit</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.intradayLimit, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</div>
                        </Col>
                    </Row>
                }
                {
                    bIsCoverBracketOrderOpen && orderInputs?.intradayTrigger > 0 &&
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>SL Trigger</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.intradayTrigger, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</div>
                        </Col>
                    </Row>
                }
                {
                    bIsCoverBracketOrderOpen && orderInputs?.intradayProfit > 0 &&
                    <>
                        {parseFloat(orderInputs?.intradayTrailing) > 0 ?
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size3 color-subtext'>Trailing SL</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size3 color-text'>{orderInputs?.intradayTrailing}</div>
                                </Col>
                            </Row> : null}
                        {parseFloat(orderInputs?.IntradayChangePrice) > 0 ?
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size3 color-subtext'>Price Change</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size3 color-text'>{orderInputs?.IntradayChangePrice}</div>
                                </Col>
                            </Row> : null}
                        <Row className='g-0 py-2'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 color-subtext'>Book Profit</div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <div className='font-regular font-size3 color-text'>{convertNumberWithCommasForCurrency(getToFixedParseFloat(orderInputs?.intradayProfit, scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), true)}</div>
                            </Col>
                        </Row>
                    </>
                }
                <Row className='g-0 py-2'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>Order Value</div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <div className='font-regular font-size3 color-text'>{changeNumberFormatWithCurrecyUnit(nOrderValue, true)}</div>
                    </Col>
                </Row>
                <Row className='g-0 py-2'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>Validity</div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start */}
                        <div className='font-regular font-size3 color-text'>{selectOrderOption?.validityTypes}</div>
                        {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End */}
                    </Col>
                </Row>
                {selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && objModalData?.data?.GTTValidDate ? <Row className='g-0 py-2'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>Valid Till</div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start */}
                        <div className='font-regular font-size3 color-text'>{objModalData?.data?.GTTValidDate}</div>
                        {/* //BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -End */}
                    </Col>
                </Row> : null}
                {
                    selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD &&
                    <Row className='g-0 py-1'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>No. of Days</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{GTDNoOfDays}</div>
                        </Col>
                    </Row>
                }
                {/*  Vaibhav Singh: NSE EQ Order Entry: DisclosedQty added in code : Start */}
                {(orderInputs?.discQty) ?
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Disclosed Qty</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{orderInputs?.discQty}</div>
                        </Col>
                    </Row> : null
                }
                {/*  Vaibhav Singh: NSE EQ Order Entry: DisclosedQty added in code :End */}
                {/* ManasaB : 10-09-2024 : Breeze -90 :LLD Creation - Below comes mapping of order slicing information in the vertical view... side tray */}
                {/* Breeze-16 : Order slicing feature :ManasaB : 10-10-2024 - Side tray order entry slicing - Start */}
                {
                    layoutType === LAYOUT_TYPE.VERTICAL && arrOrderSliceData?.length > 0 ?
                        <Row className='g-0 py-1'>
                            <Col className='text-start alert-warning p-3'>
                                {arrOrderSliceData?.length > 0 && arrOrderSliceData.map(eachInfo => {
                                    return <div className='d-flex align-items-center py-1'>
                                        <div className='allocate-dot black-allocation me-2'>&nbsp;</div>
                                        <div className='font-medium font-size2 me-1 p-t-1'>{eachInfo}</div>
                                        <div className='font-regular font-size2 p-t-1'>will be placed</div>
                                    </div>;
                                })}
                            </Col>
                        </Row> : null
                }
                {/* Breeze-16 : Order slicing feature :ManasaB : 10-10-2024 - Side tray order entry slicing -End */}
                {
                    layoutType === LAYOUT_TYPE.HORIZONTAL &&
                    <>
                        {selectOrderOption?.validityTypes !== ORDER_VALIDITY.GTT ? <>
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center' >
                                    <div className='d-flex align-items-center pe-4 cursor-pointer focus' tabIndex='0' onKeyPress={handleKeyDownOnDiv} onClick={() => marginInfoHandler()}>
                                        <div className='font-regular font-size2 color-subtext'>Approx. Margin</div>
                                        <div className='icon-16 icon-refresh icon-dark ms-2' ></div>
                                    </div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className={`font-regular font-size3 color-text ${parseFloat(arrMarginInfo?.ShortFall || 0) > 0 ? 'color-negative' : ''}`}>
                                        {isLoadingMarginInfo ? <BzDotsLoader /> : !isNaN(parseFloat(arrMarginInfo?.ApproxMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.ApproxMargin), true) : arrMarginInfo?.ApproxMargin}
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size2 color-subtext'>Available Margin</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size2 color-text'>
                                        {isLoadingMarginInfo ? <BzDotsLoader /> : !isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin}
                                    </div>
                                </Col>
                            </Row>
                        </> : null}
                        {/* BT-135270 : Order Slicing: ManasaB : 26-06-2024 - Start */}
                        {arrOrderSliceData?.length > 0 ? <Row className='g-0 py-1'>
                            <Col className='text-start alert-warning p-3'>
                                {arrOrderSliceData?.length > 0 && arrOrderSliceData.map(eachInfo => {
                                    return <div className='d-flex align-items-center py-1'>
                                        <div className='allocate-dot black-allocation me-2'>&nbsp;</div>
                                        <div className='font-medium font-size2 me-1 p-t-1'>{eachInfo}</div>
                                        <div className='font-regular font-size2 p-t-1'>will be placed</div>
                                    </div>;
                                })}
                            </Col>
                        </Row> : null}
                        {/* BT-135270 : Order Slicing: ManasaB : 26-06-2024 - End */}
                    </>
                }
                {/* Azeem K : 21-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */}
                {selectOrderOption?.isAmo ?
                    <Row className='g-0 alert-warning mt-4 p-2'>
                        <Col md={1} className='d-flex justify-content-start align-items-start'>
                            <div className='icon-20 icon-info icon-dark'></div>
                        </Col>
                        <Col md={11} className='d-flex justify-content-start align-items-start'>
                            <div className='font-medium font-size3 color-text'>After Market Order(AMO)- Order will be sent to Exchange in the next trading session</div>
                        </Col>
                    </Row> : null}
                {/* Azeem K : 21-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}
                {
                    objSingleScripOrderResp?.status === API_RESPONSE_STATUS.ERROR &&
                    <Row className='g-0 py-3'>
                        <Col className='d-flex justify-content-start'>
                            <div className='error-msg text-wrap'>{objSingleScripOrderResp?.message}</div>
                        </Col>
                    </Row>
                }
            </Container>
        );
    };

    const SipListing = ({ selectOrderOption }) => {

        // {/* BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book -- Start  */ }
        const objModalData = useSelector(state => state?.modals?.modalData);
        const { data: { orderInputs } } = objModalData;
        const orderInputsStartDate = moment(orderInputs?.startDate).endOf('day')?.format("Do MMM'YY");
        // {/* BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book -- End */ }
        //ManasaB : 25-11-2024 : Adding suffix dynamically - Start
        const getSuffix = (date) => {
            let lastDigit = date % 10;
            let lastTwoDigit = date % 100;
            if (lastTwoDigit >= 11 && lastTwoDigit <= 13) {
                return 'th';
            }
            switch (lastDigit) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };
        const strSuffix = useMemo(() => {
            if (selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY || selectOrderOption?.frequency === FREQUENCY_TYPE.FORTHNIGHTLY) {
                let suffix = getSuffix(Number(selectOrderOption?.selectSpecificFrequencyDate));
                return suffix;
            }
        }, []);
        //ManasaB : 25-11-2024 : Adding suffix dynamically - End
        return (
            scripOrderInfo?.length > 0 &&
            <Container fluid className='p-0'>
                {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */}
                {bIsOrderEntryApiPending ? <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                    <BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Placing Order" bIsFfromModal={true} />
                </div> : null}
                {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */}
                <div className='oe-confirm-buy-order-block'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text text-uppercase'>{scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-medium font-size4 color-text'>{currentScripLiveData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pb-3'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size4 color-subtext'>{scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES]}</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className={`font-regular font-size3 color-text ${Number(currentScripLiveData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) >= 0 ? 'color-positive' : 'color-negative'}`}> {currentScripLiveData[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]} (
                                {currentScripLiveData?.[WATCHLIST_GRID_INDEX.LTP_PERCENT]})</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Product Type</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>SIP</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>{selectOrderOption?.orderBy}</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{orderInputs?.quantity}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Price</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>Market</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>No. of installment</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{orderInputs?.numberOfInstallment}</div>
                        </Col>
                    </Row>
                    {/* Vinit Raut : 05-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */}
                    {orderInputs?.capPrice ? (<Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Cap Price</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-ce``nter'>
                            <div className='font-regular font-size3 color-text'>{changeNumberFormatWithCurrecyUnit(orderInputs?.capPrice)}</div>
                        </Col>
                    </Row>) : null}
                    {/* Vinit Raut : 05-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */}
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Frequency</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <div className='font-regular font-size3 color-text'>{selectOrderOption?.frequency}</div>
                        </Col>
                    </Row>
                    {/* BT-107418- 15/04/2024 - Vinit R - 28/03/2024 Breeze SIP order entry issues -- Start */}
                    {/* ManasaB : 26-11-2024 : Removed Day condition as it is not applicable in horizontal decided after seeing the code flow - Start  */}
                    {
                        (selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY || selectOrderOption?.frequency === FREQUENCY_TYPE.FORTHNIGHTLY) &&
                        <Row className='g-0 py-2'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 color-subtext'>
                                    {selectOrderOption?.day_date === 'Day' ? 'Day' : 'Date'}
                                </div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <div className='font-regular font-size3 color-text'>
                                    {/* BT-107418 - Vinit R - 09/04/2024 Breeze SIP order Book -- Start  */}
                                    {/* ManasaB : 25-11-2024 : Adding suffix dynamically - Start */}
                                    {selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY ? selectOrderOption?.selectSpecificFrequencyDate + `${strSuffix} of every month` : ''}
                                    {/* {(selectOrderOption?.frequency === 'MONTHLY' && selectOrderOption?.day_date === 'Day') ? "First " + selectOrderOption?.day : ''} */}
                                    {selectOrderOption?.frequency === FREQUENCY_TYPE.FORTHNIGHTLY ? selectOrderOption?.selectSpecificFrequencyDate + `${strSuffix}` : ''}
                                    {/* ManasaB : 26-11-2024 : Removed Day condition as it is not applicable in horizontal decided after seeing the code flow - End  */}
                                    {/* ManasaB : 25-11-2024 : Adding suffix dynamically - End */}
                                    {/* BT-107418 - Vinit R - 09/04/2024 Breeze SIP order Book -- End */}
                                </div>
                            </Col>
                        </Row>
                    }
                    {
                        selectOrderOption?.frequency === 'WEEKLY' &&
                        <Row className='g-0 py-2'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 color-subtext'>Day</div>
                            </Col>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <div className='font-regular font-size3 color-text'>Every {selectOrderOption?.everyForWeekly}</div>
                            </Col>
                        </Row>
                    }
                    {/* BT-107418- 15/04/2024 - Vinit R - 28/03/2024 Breeze SIP order entry issues -- End */}
                    <Row className='g-0 py-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext'>Starting Date</div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            {/* BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book -- Start  */}
                            <div className='font-regular font-size3 color-text'>{orderInputsStartDate}</div>
                            {/* <div className='font-regular font-size3 color-text'>{orderData?.created_date}</div> */}
                            {/* BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book -- End  */}
                        </Col>
                    </Row>
                </div>

                <div className='d-flex align-items-end'>
                    <Row className='g-0 py-3'>
                        <Col className='d-flex align-items-start'>
                            <input type="checkbox" className='form-check-input me-2' checked={bIsConfirmBtn} onChange={() => setBIsConfirmBtn(curr => !curr)} />
                            <div className='font-regular font-size2 color-text'>
                                Yes, I agree to the <a className='font-medium font-size2' onClick={termsCondition} >Terms &amp; Conditions</a>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        );
    };
    // BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    const BasketListing = () => {
        return (
            <Container fluid className='p-0'>
                {bIsOrderEntryApiPending ? <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                    <BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Placing Order" bIsFfromModal={true} />
                </div> : null}
                <Row className='g-0 mb-1'>
                    {layoutType == LAYOUT_TYPE.HORIZONTAL && <Col className='d-flex justify-content-start'>
                        <div className='font-medium font-size2 color-text me-1'>Approx. Margin: </div>
                        <div className='font-regular font-size3 color-text'>
                            {isLoadingMarginInfo ? <BzDotsLoader /> : !isNaN(parseFloat(orderCartMargin)) ? convertNumberWithCommasForCurrency(parseFloat(orderCartMargin), true) : orderCartMargin}
                        </div>
                    </Col>}
                </Row>
                <Row className='g-0 mb-2'>
                    <Col>
                        <div className='font-regular font-size4 color-text'>You're placing a basket order consisting of following scrips.</div>
                    </Col>
                </Row>
                {arrOrderDetails?.map((element) => {
                    return <>
                        <div className='g-0 py-2'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    {/* <div className='font-medium font-size4 color-text me-2'>{element?.symbol}</div> */}
                                    <div className='font-medium font-size4 color-text me-2'>{element.symbol}</div>
                                    <div className='font-regular font-size4 color-subtext me-2'>{element.series}</div>
                                    <div className='chips-wrap'>
                                        <div className='exchange-chip'>{element.exchange}</div>
                                        {/* BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start */}
                                        {objModalData?.data?.orderFrom !== 'BASKETRECO' && element?.instrument !== SCRIP_INSTRUMENTS.EQUITIES && <div className='font-regular font-size1 color-subtext ms-1'>
                                            <span className='font-regular font-size1 color-subtext'>
                                                {(element?.instrument?.indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || element?.instrument.indexOf(SCRIP_INSTRUMENTS.OPT) === 0) && element?.instrument?.indexOf(SCRIP_INSTRUMENTS.FUT) === 0 ? <span className='font-regular font-size1 color-subtext'>{`${element?.expiryDate?.slice(0, 2)} ${element?.expiryDate?.slice(2, 5).charAt(0)}${element?.expiryDate?.slice(2, 5).slice(1, 3).toLowerCase()} ${element?.expiryDate?.slice(5, 9)}`}</span> : <span className='font-regular font-size1 color-subtext'>{`${element?.expiryDate?.slice(0, 2)} ${element?.expiryDate?.slice(2, 5).charAt(0)}${element?.expiryDate?.slice(2, 5).slice(1, 3).toLowerCase()} ${element?.strikePrice} ${element?.optionType}`}</span>}</span>
                                        </div>}
                                        {/* BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End */}
                                    </div>
                                    {/* <div className='font-regular font-size4 color-subtext'>{moment(element?.expiryDate).format('DDMMMYYYY')}</div> */}
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start'>
                                    <div className={`font-medium font-size2 color-text text-nowrap me-1 ${element?.buySellType === 'BUY' ? 'color-positive' : 'color-negative'}`}>{element?.buySellType === 'BUY' ? 'Buy' : 'Sell'}:</div>
                                    <div className='font-regular font-size2 color-text text-nowrap me-1'>{`${element.productType?.charAt(0).toUpperCase()}${element.productType?.slice(1).toLowerCase()}`} </div>
                                    {/* BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Add Lot size - Start */}
                                    <div className='font-regular font-size2 color-text me-1'>{element?.count} Qty</div>
                                    {(element?.instrument.indexOf(SCRIP_INSTRUMENTS.FUT) === 0 || element?.instrument.indexOf(SCRIP_INSTRUMENTS.OPT) === 0) && <div className='font-regular font-size2 color-text me-1'>(1Lot = {element?.marketLot}Qty)</div>}
                                    {/* BREEZE-5912 : Order Cart for Derivative segment : LLD : ManasaB : 08-04-2025 : Add Lot size - End */}
                                    {/* BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - Start  */}
                                    {element?.orderType !== ORDER_ENTRY_TYPES.SL &&

                                        ['RL-MKT', 'SL-MKT'].includes(element?.orderType) ? <div className='font-regular font-size4 color-text'>@Market </div> :
                                        <div className='font-regular font-size4 color-text'>@ &#8377;{element.price}</div>
                                    }
                                    {/* BT-106965 : OrderCart: SAT2 : ManasaB : 11-06-2024 - End  */}
                                    {!element?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && element.amo && <div className='font-regular font-size4 color-text me-1'><span className='ms-1'>as</span> AMO </div>}
                                </Col>
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-start'>
                                        {element?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && element?.slTrigger > 0 && <div className='font-regular font-size4 color-text me-1'>SL Trigger : &#8377;{element?.slTrigger}</div>}
                                        {/* BT-106965 : ManasaB : 03-05-2024 : SAT2 issues - Start */}
                                        {element?.orderType === 'SL' && element?.slLimit > 0 && <div className='font-regular font-size4 color-text me-1'>SL Limit : &#8377;{element?.slLimit}</div>}
                                        {/* BT-106965 : ManasaB : 03-05-2024 : SAT2 issues - End */}
                                        {element?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && element.amo && <div className='font-regular font-size4 color-text me-1'> <span className='ms-1'>as</span> AMO </div>}
                                    </Col>
                                    {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To show Approx Margin - End  */}
                                </Row>
                            </Row>
                        </div>
                    </>;
                })}
                {arrOrderDetails?.some((eachElement) => eachElement?.amo) ?
                    <Row className='g-0 alert-warning mt-4 p-2'>
                        <Col md={1} className='d-flex justify-content-start align-items-start'>
                            <div className='icon-20 icon-info icon-dark'></div>
                        </Col>
                        <Col md={11} className='d-flex justify-content-start align-items-start'>
                            <div className='font-medium font-size3 color-text'>After Market Order(AMO)- Order will be sent to Exchange in the next trading session</div>
                        </Col>
                    </Row>
                    : null}
            </Container>
        );
    };
    // BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
    const MultiLegListing = ({ arrMultiLegInfo }) => {
        return (
            <div>
                {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */}
                {bIsOrderEntryApiPending ? <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                    <BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Placing Order" bIsFfromModal={true} />
                </div> : null}
                {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */}
                <Row className='g-0 mb-2'>
                    <Col className='d-flex justify-content-start'>
                        <div data-testid='order-entry-confirmation-modal-text' className='font-regular font-size4 color-text'>You're placing a multileg order consisting of following scrips.</div>
                    </Col>
                </Row>
                {/** Ajitesh 09-10-2024 Use correct state data/props for multileg to show proper leg data when user hits back from confirm screen in sidetray */}
                {arrMultiLegInfo?.map((element,index) => {
                    return <>
                        <div className='g-0 py-2'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start'>
                                    <div data-testid={`order-entry-confirmation-modal-symbol-${index}`} className='font-medium font-size4 color-text me-2'>{element?.symbol}</div>
                                    {/** Ajitesh 25-06-2024 Adds more data like strike pirce if scrip is option contract or option currency contract or "FUT" text if futures contract */}
                                    <div data-testid={`order-entry-confirmation-modal-expiry-${index}`} className='font-regular font-size4 color-subtext'>{moment(element?.expiryDate).format('DDMMMYYYY')} {element?.strikeprice && element?.strikeprice !== "NA" ? element?.strikeprice : "FUT"} {element?.optiontype && element?.optiontype !== "NA" ? element?.optiontype : null}</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start'>
                                    <div data-testid={`order-entry-confirmation-modal-order-type-${index}`} className={`font-medium font-size4 color-text me-1 ${element?.activeButtonToggleIndex === 0 ? 'color-positive' : 'color-negative'}`}>{element?.activeButtonToggleIndex === 0 ? 'BUY: ' : 'SELL: '}</div>
                                    <div data-testid={`order-entry-confirmation-modal-quantity-${index}`} className='font-regular font-size4 color-text me-1'>{element?.count}({element?.count * element?.ask_qty}) Lot(Qty)</div>
                                    <div data-testid={`order-entry-confirmation-modal-price-${index}`} className='font-regular font-size4 color-text'>@ {element?.orderType === 'RL-MKT' ? "Market" : `₹${element?.legPrice}`}</div>
                                </Col>
                            </Row>
                        </div>
                    </>;
                })}
            </div>
        );
    };
    //Ameersha N : 21-08-2023 : BT-107070 - Breeze - Single Scrip Order entry - Start
    const SpreadOrderListing = () => {
        return (
            //* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */}
            <Container fluid className='p-0'>

                {
                    bIsOrderEntryApiPending ?
                        <div  className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                            < BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Order Placing" bIsFfromModal={true} />
                        </div>
                        : null}
                {
                    layoutType === LAYOUT_TYPE.HORIZONTAL ? scripOrderInfo && Object?.keys(scripOrderInfo)?.length > 0 &&
                        <>
                            {/* <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-medium font-size4 color-text text-uppercase'>{scripOrderInfo?.heading}</div>
                            </Col>
                        </Row> */}
                            <Container fluid className='p-0'>
                                {scripOrderInfo?.spreadOrderPayload?.leg_details.map((scrip, index) => {
                                    return (
                                        <Row className='g-0 py-2'>
                                            <Col className='d-flex justify-content-between align-items-center'>
                                                <div data-testid={`order-entry-spread-order-confirmation-modal-symbol-${index}`} className={`font-medium font-size3 color-text ${scrip.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'}`}>{scrip.transaction_type}</div>
                                                <div data-testid={`order-entry-spread-order-confirmation-modal-expiry-${index}`} className='font-regular font-size3 color-text'>{`${scrip?.scrip_info?.symbol} ${scrip?.scrip_info?.expiry_date} ${scrip?.scrip_info?.instrument_name?.slice(0, 3)}`}</div>
                                            </Col>
                                        </Row>
                                    );
                                })}
                                <Row className='g-0 py-2'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div data-testid='order-entry-spread-order-confirmation-modal-quantity-label' className='font-regular font-size3 color-subtext'>Lot (Qty)</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-center'>
                                        <div data-testid='order-entry-spread-order-confirmation-modal-quantity' className='font-regular font-size3 color-text'>{scripOrderInfo?.quantity} ({parseInt(scripOrderInfo?.regularLot * parseInt(scripOrderInfo?.quantity))})</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-2'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div data-testid='order-entry-spread-order-confirmation-modal-price-label' className='font-regular font-size3 color-subtext'>Price</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-center'>
                                        <div data-testid='order-entry-spread-order-confirmation-modal-price' className='font-regular font-size3 color-text'>{scripOrderInfo?.orderType === "RL" ? `₹${parseFloat(scripOrderInfo?.price).toFixed(scripOrderInfo?.decimalLocatorLength)}` : "Market"}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-2'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div data-testid='order-entry-spread-order-confirmation-modal-validity-label' className='font-regular font-size3 color-subtext'>Validity</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-center'>
                                        <div data-testid='order-entry-spread-order-confirmation-modal-validity' className='font-regular font-size3 color-text'>{scripOrderInfo?.validity}</div>
                                    </Col>
                                </Row>
                            </Container>
                        </>
                        : multiSpreadOrderInfo && Object?.keys(multiSpreadOrderInfo)?.length > 0 &&
                        <Container fluid className='p-0'>
                            <div className='font-medium font-size5 color-text'>{multiSpreadOrderInfo?.heading}</div>
                            {multiSpreadOrderInfo?.spreadOrderPayload?.leg_details.map(scrip => {
                                return (
                                    <Row className='g-0 py-2'>
                                        <Col className='d-flex justify-content-between align-items-center'>
                                            <div className={`font-medium font-size3 color-text ${scrip.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'}`}>{scrip.transaction_type}</div>
                                            <div className='font-regular font-size3 color-text'>{`${scrip?.scrip_info?.symbol} ${scrip?.scrip_info?.expiry_date} ${scrip?.scrip_info?.instrument_name?.slice(0, 3)}`}</div>
                                        </Col>
                                    </Row>
                                );
                            })}
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size3 color-subtext'>Lot (Qty)</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size3 color-text'>{multiSpreadOrderInfo?.quantity} ({parseInt(multiSpreadOrderInfo?.regularLot * parseInt(multiSpreadOrderInfo?.quantity))})</div>
                                </Col>
                            </Row>
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size3 color-subtext'>Price</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size3 color-text'>{multiSpreadOrderInfo?.orderType === ORDER_ENTRY_TYPES.RL ? `₹${parseFloat(multiSpreadOrderInfo?.price).toFixed(multiSpreadOrderInfo?.decimalLocatorLength)}` : "Market"}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 py-2'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size3 color-subtext'>Validity</div>
                                </Col>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size3 color-text'>{multiSpreadOrderInfo?.validity}</div>
                                </Col>
                            </Row>
                        </Container>
                }
            </Container >
            //* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */}
        );
    };
    //Ameersha N : 21-08-2023 : BT-107070 - Breeze - Single Scrip Order entry - End



    switch (orderEntryTab) {
        case ORDER_TYPES.SINGLE_SCRIP: {
            return <SingleScripListing />;
        }
        case ORDER_TYPES.EQUITY_SIP: {
            return <SipListing selectOrderOption={selectOrderOption} />;
        }
        case ORDER_TYPES?.MULTI_SCRIP: {
            if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.SPREAD) {
                return <SpreadOrderListing />;
            }
            // BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
            else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.BASKET) {
                return <BasketListing />;
            }
            else {
                return <MultiLegListing arrMultiLegInfo={arrMultiLegInfo} />; {/**Ajitesh 10-10-2024 Adds prop for multileg data from redux to show in confirmation */ }
            }
            // BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
        }
        default:
            break;
    }
};

export default memo(ConfirmationBody);
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End